const validTimeDurationRegex =
  /^\d+\s(?:minute|minute|minutes|day|days|hour|hours)$/;

export const refineDuration = [
  (value: string | undefined) => {
    if (!value) {
      return true;
    }
    return validTimeDurationRegex.test(value);
  },
  {
    message: 'Must be in the format of "1 minute" or "2 days", etc',
  },
] as const;

export const refineColumnName = [
  (value: string) => {
    if (!value) {
      return true;
    }
    // Database column name validation regex
    // Allows letters, numbers, underscores, dots
    // Must start with a letter or underscore
    // Must not end with a dot
    const validColumnNameRegex = /^[a-zA-Z_][a-zA-Z0-9_.]*[a-zA-Z0-9_]$/;
    return validColumnNameRegex.test(value);
  },
  'Column name must start with a letter or underscore and can only contain letters, numbers, underscores, and dots',
] as const;

export const refineTableName = [
  (value: string) => {
    if (!value) {
      return true;
    }
    // Database table name validation regex
    // Allows letters, numbers, underscores, periods, and backticks
    // Must start with a letter or underscore
    const validTableNameRegex = /^[a-zA-Z_][a-zA-Z0-9_.`]*$/;
    return validTableNameRegex.test(value);
  },
  'Table name must start with a letter or underscore and can only contain letters, numbers, underscores, periods, and backticks',
] as const;
